export enum AIWorkflowsApiTag {
  info = "info",
}
